import { useFacilityContext } from '@aspendental/shared-components-web';
import { Typography, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'next-i18next';
import PhoneNumberLink from '@src/components/PhoneNumberLink';
import { FALLBACK_FACILITY_PHONE_NUMBER } from '@src/constants';
import { wordWrapStyling } from './styles';
export default function FurtherAssistanceContact({
  directAction = false
}: {
  directAction?: boolean;
}) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const facilityDetails = useFacilityContext();
  const {
    officeInfo
  } = facilityDetails;
  const localFacilityNumber = officeInfo?.technicalInfrastructure?.phoneNumber ?? FALLBACK_FACILITY_PHONE_NUMBER;
  const {
    t
  } = useTranslation('furtherAssistanceContact');
  const fontVariant = isSmallScreen ? 'bodyMediumBook' : 'bodyLargeBook';
  if (directAction) {
    return <Typography color="primary.main" variant={fontVariant} sx={{
      textAlign: 'center'
    }} data-test-id="text_further_assistance">
				{t('directAction1')} <PhoneNumberLink phoneNumber={localFacilityNumber} variant={fontVariant} />{' '}
				{t('directAction2')}
			</Typography>;
  }
  return <Typography sx={wordWrapStyling(isSmallScreen)} color="primary.main" variant={fontVariant} data-test-id="text_further_assistance" data-sentry-element="Typography" data-sentry-component="FurtherAssistanceContact" data-sentry-source-file="FurtherAssistanceContact.tsx">
			{t('indirectAction1')}
			<Typography component="span" color="primary.main" variant={fontVariant} data-sentry-element="Typography" data-sentry-source-file="FurtherAssistanceContact.tsx">
				{t('indirectAction2')}
				<PhoneNumberLink phoneNumber={localFacilityNumber} variant={fontVariant} data-sentry-element="PhoneNumberLink" data-sentry-source-file="FurtherAssistanceContact.tsx" />
			</Typography>
		</Typography>;
}